var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgArrowLeftinline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 114,
    height: 71,
    viewBox: "0 0 114 71",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.139 70.734a1.187 1.187 0 01-1.548-.648L.543 60.202a1.187 1.187 0 112.197-.9l3.598 8.786 8.786-3.598a1.187 1.187 0 11.9 2.197l-9.885 4.047zm106.48-56.371c-.521-.15-1.218-.487-1.979-.877-.783-.401-1.777-.935-2.891-1.518-2.257-1.178-5.166-2.64-8.61-4.024-6.892-2.772-15.886-5.222-25.974-4.486-20.04 1.46-44.986 15.565-66.381 66.637l-2.19-.917C26.18 17.654 51.72 2.64 72.994 1.09c10.569-.77 19.938 1.8 27.031 4.651 3.549 1.428 6.538 2.93 8.824 4.124 1.157.604 2.096 1.11 2.874 1.508.799.41 1.293.633 1.557.71l-.66 2.28z",
    fill: "#000"
  })));
}

export default SvgArrowLeftinline;